import { BlockComponentFactory } from '../BlockFactory'
import Image from 'antd/lib/image'
import { ImageBlockProps } from './block-props.types'
import { LABEL_BOLD_FONT_STYLE } from '../../constants'
import { LabelBlock } from './LabelBlock'
import Flex from 'antd/lib/flex'
import { useSignedURL } from '../../../service/hooks/use-signed-url'
import ImagePlaceholderImage from '../../../assets/images/image-placeholder.png'
import { toCSSSize } from './block-utils'

export const ImageBlockComponent = BlockComponentFactory.createBlockComponent<ImageBlockProps>(
    props => {
        const {
            src,
            label,
            alt,
            infoText,
            width,
            height,
            visibility = 'visible',
            disabled = false,
            style,
        } = props

        const { url: imageURL, isLoading } = useSignedURL(src)

        const containerStyle: React.CSSProperties = {
            ...style,
            display: visibility === 'hidden' ? 'none' : 'flex',
            flexDirection: 'column',
            gap: '8px',
            width: toCSSSize(width) ?? 'auto',
            height: toCSSSize(height) ?? 'auto',
            backgroundColor: '#f0f0f0',
            minHeight: '200px',
        }

        const imageStyle: React.CSSProperties = {
            height: toCSSSize(height) || '100%',
            objectFit: 'fill',
        }

        return (
            <div style={containerStyle}>
                <LabelBlock label={label} infoText={infoText} labelStyle={LABEL_BOLD_FONT_STYLE} />
                {imageURL ? (
                    <Image
                        src={imageURL}
                        alt={alt ?? label ?? 'Image'}
                        style={imageStyle}
                        preview={!disabled}
                    />
                ) : (
                    <Flex flex={1} justify="center" align="center">
                        {isLoading ? (
                            'Loading image...'
                        ) : (
                            <Image
                                src={ImagePlaceholderImage}
                                style={{ ...imageStyle, height: toCSSSize(height) || '200px' }}
                                alt={alt ?? label ?? 'Image'}
                                width={'100%'}
                            />
                        )}
                    </Flex>
                )}
            </div>
        )
    }
)
